// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.individuals-page .card-body {
  padding: 1.5rem;
}

.individuals-layout {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.individuals-summary-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}

.individuals-summary-card {
  background: linear-gradient(135deg, #f8fbff 0%, #eef5ff 100%);
  border: 1px solid #d7e6fb;
  border-radius: 1rem;
  color: #133a63;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 1rem 1.1rem;
  text-align: left;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.individuals-summary-card:hover,
.individuals-summary-card.is-active {
  border-color: #0d6efd;
  box-shadow: 0 12px 30px rgba(13, 110, 253, 0.12);
  transform: translateY(-1px);
}

.individuals-summary-label {
  font-size: 0.9rem;
  font-weight: 600;
}

.individuals-summary-value {
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1;
}

.individuals-relationship-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.individuals-searchable-table {
  border: 1px solid #e3ebf4;
  border-radius: 1rem;
  overflow: hidden;
  padding: 1rem;
  background: linear-gradient(180deg, #fbfdff 0%, #f4f8fc 100%);
}

.individuals-searchable-table .card,
.individuals-searchable-table .accordion,
.individuals-searchable-table .table-responsive {
  border-radius: 1rem;
}

.individuals-searchable-table .table {
  margin-bottom: 0;
}

.individuals-searchable-table thead th {
  background: #f6f9fc;
  border-bottom-width: 1px;
  color: #47627d;
  font-size: 0.85rem;
  text-transform: uppercase;
}

.individuals-searchable-table th:last-child,
.individuals-searchable-table td:last-child {
  min-width: 7rem;
  white-space: nowrap;
  width: 7rem;
}

.individuals-searchable-table td:nth-child(1),
.individuals-searchable-table th:nth-child(1) {
  width: 14%;
}

.individuals-searchable-table td:nth-child(2),
.individuals-searchable-table th:nth-child(2) {
  width: 18%;
}

.individuals-searchable-table .btn-primary,
.individuals-searchable-table .btn-outline-primary:hover {
  box-shadow: 0 8px 18px rgba(13, 110, 253, 0.14);
}

.individuals-searchable-table input,
.individuals-searchable-table select {
  border-radius: 0.85rem;
}

.individuals-searchable-table .pagination {
  margin-top: 1rem;
}

@media (max-width: 767px) {
  .individuals-searchable-table {
    padding: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Individuals/Individuals.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".individuals-page .card-body {\n  padding: 1.5rem;\n}\n\n.individuals-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.individuals-summary-grid {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n}\n\n.individuals-summary-card {\n  background: linear-gradient(135deg, #f8fbff 0%, #eef5ff 100%);\n  border: 1px solid #d7e6fb;\n  border-radius: 1rem;\n  color: #133a63;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 1rem 1.1rem;\n  text-align: left;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.individuals-summary-card:hover,\n.individuals-summary-card.is-active {\n  border-color: #0d6efd;\n  box-shadow: 0 12px 30px rgba(13, 110, 253, 0.12);\n  transform: translateY(-1px);\n}\n\n.individuals-summary-label {\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.individuals-summary-value {\n  font-size: 1.8rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.individuals-relationship-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.individuals-searchable-table {\n  border: 1px solid #e3ebf4;\n  border-radius: 1rem;\n  overflow: hidden;\n  padding: 1rem;\n  background: linear-gradient(180deg, #fbfdff 0%, #f4f8fc 100%);\n}\n\n.individuals-searchable-table .card,\n.individuals-searchable-table .accordion,\n.individuals-searchable-table .table-responsive {\n  border-radius: 1rem;\n}\n\n.individuals-searchable-table .table {\n  margin-bottom: 0;\n}\n\n.individuals-searchable-table thead th {\n  background: #f6f9fc;\n  border-bottom-width: 1px;\n  color: #47627d;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n}\n\n.individuals-searchable-table th:last-child,\n.individuals-searchable-table td:last-child {\n  min-width: 7rem;\n  white-space: nowrap;\n  width: 7rem;\n}\n\n.individuals-searchable-table td:nth-child(1),\n.individuals-searchable-table th:nth-child(1) {\n  width: 14%;\n}\n\n.individuals-searchable-table td:nth-child(2),\n.individuals-searchable-table th:nth-child(2) {\n  width: 18%;\n}\n\n.individuals-searchable-table .btn-primary,\n.individuals-searchable-table .btn-outline-primary:hover {\n  box-shadow: 0 8px 18px rgba(13, 110, 253, 0.14);\n}\n\n.individuals-searchable-table input,\n.individuals-searchable-table select {\n  border-radius: 0.85rem;\n}\n\n.individuals-searchable-table .pagination {\n  margin-top: 1rem;\n}\n\n@media (max-width: 767px) {\n  .individuals-searchable-table {\n    padding: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
